var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "l-map",
        {
          ref: "map",
          style: "height:" + _vm.map_height + "px;",
          attrs: {
            zoom: _vm.mapInfo.zoom,
            center: _vm.mapInfo.center,
            options: { zoomControl: false, scrollWheelZoom: false }
          },
          on: { "update:center": _vm.centerUpdated }
        },
        [
          _c("v-tilelayer", {
            attrs: {
              url: _vm.mapInfo.url,
              attribution: _vm.mapInfo.attribution
            }
          }),
          _vm._v(" "),
          _c("l-control-zoom", { attrs: { position: "topright" } }),
          _vm._v(" "),
          _c(
            "v-marker-cluster",
            { attrs: { options: _vm.mapInfo.clusterOptions } },
            _vm._l(_vm.find, function(item, index) {
              return _c(
                "span",
                { key: index },
                [
                  item.positions.markers.length
                    ? _c(
                        "v-marker",
                        {
                          attrs: {
                            id: "mark" + item.ID,
                            "lat-lng": _vm.pos(
                              item.positions.markers[0].lat,
                              item.positions.markers[0].lng
                            ),
                            icon: _vm.getIconByTax(
                              item.categories[0]
                                ? item.categories[0].term_id
                                : -1
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectItem($event, item.ID)
                            },
                            mouseover: function($event) {
                              return $event.target.openPopup()
                            },
                            mouseleave: function($event) {
                              return $event.target.closePopup()
                            }
                          }
                        },
                        [
                          _c("v-popup", { attrs: { content: item.post_title } })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isMobile,
              expression: "!isMobile"
            }
          ],
          staticClass: "leaflet-sidebar show-for-large",
          attrs: { id: "filter-control" }
        },
        [
          _c("h5", [_vm._v(_vm._s(_vm.$t("legende")))]),
          _vm._v(" "),
          _vm._l(_vm.categories, function(category, index) {
            return _c("span", { key: index }, [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  id: "cat" + index,
                  name: "cat" + index
                },
                on: {
                  change: function($event) {
                    return _vm.categoryFilter(category.term_id)
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "cat" + index } }, [
                _c("i", {
                  staticClass: "fa fa-map-marker-alt fa-1x",
                  style: "color:" + category.markerColor
                }),
                _vm._v(" " + _vm._s(category.name) + "\n      ")
              ]),
              _vm._v(" "),
              _c("br")
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "leaflet-sidebar card",
          attrs: {
            id: "info-control",
            "data-equalizer-watch": "item",
            "data-equalize-by-row": "true"
          }
        },
        [
          _vm.selectedItem.image
            ? _c("img", {
                staticClass: "itemImage",
                attrs: { src: _vm.selectedItem.image[0], alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "card-section" }, [
            _c("h4", { staticClass: "cl-blue" }, [
              _c("strong", [_vm._v(_vm._s(_vm.selectedItem.post_title))])
            ]),
            _vm._v(" "),
            _vm.selectedItem.direction
              ? _c("p", [
                  _c("i", {
                    staticClass: "fa fa-map-marked-alt fa-2x",
                    staticStyle: { color: "blue" }
                  }),
                  _vm._v(" " + _vm._s(_vm.selectedItem.direction))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedItem.contact
              ? _c("p", [
                  _c("i", {
                    staticClass: "fa fa-phone-square-alt fa-2x",
                    staticStyle: { color: "blue" }
                  }),
                  _c(
                    "a",
                    { attrs: { href: "tel:" + _vm.selectedItem.contact } },
                    [_vm._v(" " + _vm._s(_vm.selectedItem.contact))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedItem.mail
              ? _c("p", [
                  _c("i", {
                    staticClass: "fa fa-envelope-square fa-2x",
                    staticStyle: { color: "blue" }
                  }),
                  _c(
                    "a",
                    { attrs: { href: "mailto:" + _vm.selectedItem.mail } },
                    [_vm._v(" " + _vm._s(_vm.selectedItem.mail))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedItem.referring_person
              ? _c("p", [
                  _c("i", {
                    staticClass: "fa fa-user fa-2x",
                    staticStyle: { color: "blue" }
                  }),
                  _vm._v(" " + _vm._s(_vm.selectedItem.referring_person))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedItem.social_media
              ? _c("p", [
                  _c("i", {
                    staticClass: "fa fa-share-alt fa-2x",
                    staticStyle: { color: "blue" }
                  }),
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: _vm.selectedItem.social_meida
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.selectedItem.social_meida))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedItem.web
              ? _c("p", [
                  _c("i", {
                    staticClass: "fa fa-globe fa-2x",
                    staticStyle: { color: "blue" }
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: _vm.selectedItem.web } },
                    [_vm._v(" " + _vm._s(_vm.selectedItem.web))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "hollow button tiny close-btn",
                attrs: { type: "button" },
                on: { click: _vm.unSelectedItem }
              },
              [_vm._v("X")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a29eb0ba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /builds/bezeroak/translanekin/translanekin-theme/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a29eb0ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/builds/bezeroak/translanekin/translanekin-theme/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/mapa.vue
// module id = 118
// module chunks = 0